import { render, staticRenderFns } from "./serviceModal.vue?vue&type=template&id=0f12c4fd&scoped=true&"
import script from "./serviceModal.vue?vue&type=script&lang=js&"
export * from "./serviceModal.vue?vue&type=script&lang=js&"
import style0 from "./serviceModal.vue?vue&type=style&index=0&id=0f12c4fd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f12c4fd",
  null
  
)

export default component.exports